import {Dictionary} from 'lodash'
import {FC} from 'react'

import {Link, Trans, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextFontWeight, TextVariant} from '../content/Text'
import {CheckCircleIcon} from '../icons/CheckCircleIcon'

export type IncludedBenefitType = {
  title: string
  description?: string
  linkUrl?: string
  linkText?: string
  variables?: Dictionary<any>
}

export const IncludedBenefit: FC<React.PropsWithChildren<IncludedBenefitType>> = ({
  title,
  description,
  linkUrl,
  linkText,
  variables,
}) => {
  const {t} = useTranslation()

  return (
    <>
      <div className="benefit">
        <div className="checkmark">
          <CheckCircleIcon />
        </div>
        <div>
          <Text variant={TextVariant.h5} element="h3" fontWeight={TextFontWeight.bold}>
            {t(title)}
          </Text>
          <div className="description">
            <Text color={theme.palette.text.light}>
              <Trans t={t} i18nKey={description} values={{...variables}} />
              {linkUrl && linkText && (
                <>
                  {' '}
                  <Link href={linkUrl} legacyBehavior>
                    <a className="link" target="_blank">
                      {t(linkText)}
                    </a>
                  </Link>
                </>
              )}
            </Text>
          </div>
        </div>
      </div>

      <style jsx>{`
        .benefit {
          display: flex;
        }
        .checkmark {
          margin-top: ${theme.spacing[1]};
          margin-right: ${theme.spacing[3]};
        }
        .description {
          margin-top: ${theme.spacing[2]};
        }
        .link {
          color: inherit;
          text-decoration: underline;
        }
        .link:hover {
          text-decoration: none;
        }
        @media ${MOBILE_SCREENSIZE} {
          .description {
            margin-top: ${theme.spacing[1]};
          }
        }
      `}</style>
    </>
  )
}
